<ng-container *ngIf="isSlider; else scroller">
  <nav class="productDiscover__container">
    <div class="productDiscover__slider" #slider>
      <div class="productDiscover__item" *ngFor="let product of products; let i = index">
        <vc-catalog-snippet
          [index]="i"
          [likedItem]="likedItem"
          [product]="product"
          [seoContext]="seoContext"
          [eventToObserve]="eventClick"
          [isArrangement]="true"
        ></vc-catalog-snippet>
      </div>
      <ng-container *ngIf="isMdUp && products.length > itemMin">
        <button
          class="mainControl mainControl--mainPrev"
          [ngClass]="{'mainControl--clickable': prevClickable}"
          (click)="scrollToPrev(slider)"
          aria-hidden="true"
          tabindex="-1"
        >
          <vc-sprite-icons name="arrow-head-left-thick"></vc-sprite-icons>
        </button>
        <button
          class="mainControl mainControl--mainNext"
          [ngClass]="{'mainControl--clickable': nextClickable}"
          (click)="scrollToNext(slider)"
          aria-hidden="true"
          tabindex="-1"
        >
          <vc-sprite-icons name="arrow-head-left-thick"></vc-sprite-icons>
        </button>
      </ng-container>
    </div>
  </nav>
</ng-container>

<!-- scroller display -->
<ng-template #scroller>
  <nav class="row row--gutter10 row-md--gutter20 productDiscover__scroller">
    <div class="col-6 col-md-4 col-lg-3 productDiscover__item" *ngFor="let product of products; let i = index">
      <vc-catalog-snippet
        class="productDiscover__item__snippet"
        [index]="i"
        [likedItem]="likedItem"
        [product]="product"
        [seoContext]="seoContext"
        [eventToObserve]="eventClick"
        [isArrangement]="true"
      ></vc-catalog-snippet>
    </div>
  </nav>
</ng-template>
